module.exports = __webpack_public_path__ + "static/media/idiom_title.f49a7a3d.svg";